module.exports = "/images/link-web.svg?af071341e7f2aa849a82973633210e5d";